import { render, staticRenderFns } from "./UserManagementSetting.vue?vue&type=template&id=753f0fe0"
import script from "./UserManagementSetting.vue?vue&type=script&lang=js"
export * from "./UserManagementSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports